const state = {
  notReadNumber: 0,
  authTree: []
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js